import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'slides-ac',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/slides-ac/slides-ac.component').then(m => m.SlidesAcComponent)
  },
  {
    path: 'slides-vt',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/slides-vt/slides-vt.component').then(m => m.SlidesVtComponent)
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
  }
];
